var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2172",
    d: "M0.916016 7.83073C0.916016 4.68803 0.916016 3.11668 1.95335 2.14037C2.99068 1.16406 4.66023 1.16406 7.99935 1.16406H8.64329C11.361 1.16406 12.7198 1.16406 13.6635 1.82893C13.9338 2.01942 14.1739 2.24533 14.3763 2.4998C15.0827 3.38796 15.0827 4.66686 15.0827 7.22467V9.34588C15.0827 11.8152 15.0827 13.0498 14.6919 14.0359C14.0637 15.6212 12.7351 16.8717 11.0507 17.4629C10.003 17.8307 8.69117 17.8307 6.06753 17.8307C4.56831 17.8307 3.8187 17.8307 3.22 17.6206C2.25751 17.2827 1.49831 16.5681 1.13932 15.6623C0.916016 15.0988 0.916016 14.3933 0.916016 12.9822V7.83073Z",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0833 9.5C15.0833 11.0341 13.8397 12.2778 12.3056 12.2778C11.7507 12.2778 11.0966 12.1806 10.5572 12.3251C10.0779 12.4535 9.70353 12.8279 9.5751 13.3072C9.43056 13.8466 9.52778 14.5007 9.52778 15.0556C9.52778 16.5897 8.28412 17.8333 6.75 17.8333",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4381",
    d: "M4.66602 5.32812H10.4993",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4382",
    d: "M4.66602 8.66406H7.16602",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.1581230040a9eccc3aa83f4fb14b1ff1.svg";
export { ForwardRef as ReactComponent };